import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PromptComponent } from 'src/app/includes/popups/prompt/prompt.component';
import { CustomSnackBar } from 'src/app/utilities/custom-snack-bar/custom-snack-bar.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class DesignUtilityServices {
  // New Subjects for Updated Header Concepts
  headerColor = new BehaviorSubject(''); // For Header Color
  sideNavClose = new BehaviorSubject(false);
  onboard = new BehaviorSubject(false);
  onboardVisibility = new BehaviorSubject(false);

  constructor(
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private customSnackBar: CustomSnackBar,
    private injector: Injector
  ) {}

  //------------------------------------------//
  // Custom Prompt                            //
  //------------------------------------------//
  openPrompt(promptData): Observable<any> {
    const dialogRef = this.dialog.open(PromptComponent, {
      data: promptData,
      maxWidth: '400px',
      width: '90%',
    });

    return dialogRef.afterClosed();
  }

  //------------------------------------------//
  // Custom SnakeBar                          //
  //------------------------------------------//
  openSnackBar(
    message: string,
    action: string,
    duration: number,
    className: string
  ): void {
    this.snackBar.open(message, action, {
      duration: duration * 1000,
      panelClass: [className],
    });
  }

  openCustomSnackBar(message: string, action: string, type: string) {
    const translate = this.injector.get(TranslateService); // Inject TranslateService dynamically
    const translatedMessage = translate.instant(message);
    const translatedAction = translate.instant(action);

    switch (type) {
      case 'success':
        this.customSnackBar.successMessage(translatedMessage, translatedAction);
        break;
      case 'info':
        this.customSnackBar.infoMessage(translatedMessage, translatedAction);
        break;
      case 'error':
        this.customSnackBar.errorMessage(translatedMessage, translatedAction);
        break;
      default:
        console.warn(`Unknown snackbar type: ${type}`);
    }
  }

  //------------------------------------------//
  // Hex to RGBA                              //
  //------------------------------------------//
  hexToRgbA(hex, opacity) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('');
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = '0x' + c.join('');
      return (
        'rgba(' +
        [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') +
        ',' +
        opacity +
        ')'
      );
    }
    throw new Error('Bad Hex');
  }
}
